export function checarGrupo (grupo, tipo) {
  if (!this.hasOwnProperty(grupo)) {
    throw new Error(`Grupo ${grupo} não registrado`)
  }
  return this[grupo].includes(tipo)
}

export function checarFuncao (funcao) {
  if (!this.hasOwnProperty(funcao)) {
    throw new Error(`Função ${funcao} não registrada`)
  }
  return this[funcao]
}



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/config-tipos-relatorio/helpers.js